<template>
  <bootstrap-modal
    :has-header="false"
    :has-footer="false"
    :is-open="isModalOpen"
    size="sm"
  >
    <div class="col-12">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="d-flex justify-content-center">
            <div
              class="spinner-grow text-danger"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div
              class="spinner-grow text-warning"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div
              class="spinner-grow text-success"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div
              class="spinner-grow text-primary"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </bootstrap-modal>
</template>
<script>
import BootstrapModal from '~bootstrap/Modal'
import { mapActions } from 'vuex'
export default {
  name: 'PageLoaderModal',
  components: {
    BootstrapModal
  },
  props: {
    isModalOpen: Boolean
  },
  watch: {
    isModalOpen (value) {
      this.toggleModal(value)
    }
  },
  methods: {
    ...mapActions('layouts', [
      'toggleModal'
    ])
  }
}
</script>
